import React from 'react'
import './Bfooter.css'

export const Bfooter = () => {
  return (
    <footer className="bfooter text-white pt-5 pb-4">
    <div className="container text-dark text-md-left">
      <div className="row text-md-left">
        {/* About Section */}
        <div className="col-4 mx-auto mt-3">
          <h5 className="text-uppercase mb-4 font-weight-bold heading">About Us</h5>
          <p>
          We supply quality building materials like cement, bricks, sand, tiles, and granite at affordable prices. Our focus is on timely delivery, reliable service, and customer satisfaction. Whether it's a small project or large construction, we’re here to support your building needs every step of the way.
          </p>
        </div>

        {/* Contact Info */}
        <div className="col-4 mx-auto mt-3">
          <h5 className="text-uppercase mb-4 font-weight-bold heading">Contact</h5>
          <p>
            <i className="fas fa-phone-alt me-2"></i>
            <a href="tel:+919380662618" style={{ textDecoration: 'none', color: 'inherit' }}>
              +91 9380662618
            </a>
            </p>
            <p>
            <i className="fas fa-envelope me-2"></i>
            <a href="mailto:support@shreeshyamenterpris.com" style={{ textDecoration: 'none', color: 'inherit' }}>
              support@shreeshyamenterpris.com
            </a>
            </p>
            <p>
            <i className="fas fa-globe me-2"></i>
            <a href="https://www.shreeshyamenterpris.com" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
              www.shreeshyamenterpris.com
            </a>
            </p>
        </div>

        {/* Location */}
        <div className="col-4 mx-auto mt-3">
          <h5 className="text-uppercase mb-4 font-weight-bold heading">Location</h5>
          <p><i className="fas fa-map-marker-alt me-2"></i>Near Sai Baba Temple, Jaipur Road,Ratan Nagar,Churu,Rajasthan</p>
          <p><i className="fas fa-clock me-2"></i>Mon - Sat: 7:00am - 7:30pm</p>
        </div>

        {/* Important Links */}
        {/* <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mt-3">
          <h5 className="text-uppercase mb-4 font-weight-bold heading">Quick Links</h5>
          <p><a href="/" className="text-primary text-decoration-none">Home</a></p>
          <p><a href="/about" className="text-primary text-decoration-none">About</a></p>
          <p><a href="/contact" className="text-primary text-decoration-none">Contact</a></p>
          <p><a href="/products" className="text-primary text-decoration-none">Products</a></p>
        </div> */}

        {/* Send Mail Form */}
        {/* <div className="col-md-4 col-lg-4 col-xl-4 mx-auto mt-3">
          <h5 className="text-uppercase mb-4 font-weight-bold heading">Send Us a Message</h5>
          <form>
            <div className="form-group mb-2">
              <input type="email" className="form-control" placeholder="Your Email" required />
            </div>
            <div className="form-group mb-2">
              <textarea className="form-control" rows="2" placeholder="Your Message" required></textarea>
            </div>
            <button className="btn btn-warning btn-sm" type="submit">Send</button>
          </form>
        </div>*/}
      </div> 

     
    </div>
  </footer>
  )
};
